export const TYPE_SET = 'type_set'

export const TYPE_TREATMENT = 'type_treatment'

export const PAYMENT_METHOD_CREDIT_CARD = 'credit_card'

export const PAYMENT_METHOD_PREPAYMENT = 'prepayment'

export const PAYMENT_METHOD_KLARNA = 'klarna'

export const PAYMENT_METHOD_SEPA = 'sepa'

export const PAYMENT_METHOD_PAYPAL_RATE_PAY = 'paypal_ratepay'

export const PAYMENT_METHOD_PAYPAL = 'paypal'

export const PAYMENT_METHOD_PLEDG_RATE_PAY = 'pledg_ratepay'

export const PAYMENT_METHOD_CHRYSALIS_RATE_PAY = 'chrysalis_ratepay'



// WEBPACK FOOTER //
// ./src/constant/sales-order-constant.js